"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WRAPPER_PADDING_LEFT = exports.TAB_MARGIN_RIGHT = exports.TEXTAREA_LINE_HEIGHT = exports.MODAL_MAX_WIDTH_LARGE = exports.MODAL_MAX_WIDTH_SMALL = exports.FOCUS_OUTLINE_WIDTH = exports.MIN_TARGET_SIZE = exports.VIEWPORT_MARGIN = exports.ASIDE_MAX_WIDTH = exports.HEADER_HEIGHT = void 0;
exports.HEADER_HEIGHT = 70;
exports.ASIDE_MAX_WIDTH = 220;
exports.VIEWPORT_MARGIN = 7;
exports.MIN_TARGET_SIZE = 34;
exports.FOCUS_OUTLINE_WIDTH = 3;
exports.MODAL_MAX_WIDTH_SMALL = 500;
exports.MODAL_MAX_WIDTH_LARGE = 800;
exports.TEXTAREA_LINE_HEIGHT = 20;
// TABS COMPONENT
exports.TAB_MARGIN_RIGHT = 20;
exports.WRAPPER_PADDING_LEFT = 14;
//# sourceMappingURL=dimensions.js.map